import { Hint, Label, Select } from '@lokalise/louis';

type Option = { value: string; label: string };

interface FilterByFileNameInputProps {
    value: readonly Option[];
    options: readonly Option[];
    onChange: (value: readonly Option[]) => void;
}

const FilterByFileNameInput = ({ value, options, onChange }: FilterByFileNameInputProps) => (
    <Label
        text={
            <>
                File name{' '}
                <Hint placement="top">
                    Only keys attributed to selected files will be included. Leave empty for all.
                </Hint>
            </>
        }
        id="FilterByFileNameInput"
    >
        <Select
            value={value}
            options={options}
            isMulti
            onChange={onChange}
            aria-labelledby="FilterByFileNameInput"
            placeholder="Search for a file"
        />
    </Label>
);

export default FilterByFileNameInput;
